import { createCachedSelector } from "re-reselect";

import type { PollService } from "@busbud/core-types";

import { getLegCitiesAndLocations } from "../legs/get-leg-cities-and-locations";

export const getCityAndLocationLabels = (
  city: PollService.API.CityDetails | undefined | null,
  location: PollService.API.RelatedPublicStop | undefined
) => {
  const { name: location_name } = location || { name: "-" }; // Very unlikely, in case we don't find the location
  const city_name = city ? city.name : "-"; // Very unlikely, in case we don't find the locations's city

  return { city: city_name, location: location_name };
};

export const getLegLocationLabels = createCachedSelector(
  [getLegCitiesAndLocations],
  ({
    origin_city,
    origin_location,
    destination_city,
    destination_location
  }) => {
    const origin_labels = getCityAndLocationLabels(
      origin_city,
      origin_location
    );

    const destination_labels = getCityAndLocationLabels(
      destination_city,
      destination_location
    );

    return {
      origin_labels,
      destination_labels
    };
  }
)((_state, trip_id) => trip_id);

const getCityAndLocationLabelsParams = ({
  trips_locations,
  trips_cities,
  location_id
}: {
  trips_locations: Record<string, PollService.API.RelatedPublicStop>;
  trips_cities: Record<string, PollService.API.CityDetails>;
  location_id: string;
}) => {
  const location = trips_locations[location_id];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const city = location.city_id ? trips_cities[location.city_id] : null;
  return { city, location };
};

export const getLocationLabel = ({
  trips_locations,
  trips_cities,
  location_id
}: {
  trips_locations: Record<string, PollService.API.RelatedPublicStop>;
  trips_cities: Record<string, PollService.API.CityDetails>;
  location_id: string | number;
}) => {
  const { city, location } = getCityAndLocationLabelsParams({
    location_id: `${location_id}`,
    trips_locations,
    trips_cities
  });

  return getCityAndLocationLabels(city, location);
};
